import { useMedias } from "@/api/media";
import { MISSING_ID_IN_ROUTE } from "@/utils/constant";
import { useMemo } from "react";
import { CODE_META } from "./useCheckingProfileValidations";

export default function useDefaultSupportingDocuments({
  rfsId,
}: {
  rfsId?: string;
}) {
  if (!rfsId) {
    throw new Error(MISSING_ID_IN_ROUTE);
  }

  const { data: medias } = useMedias({
    entityId: rfsId,
    sort: "createdDate",
    asc: "false",
  });

  const defaultSupportingDocuments = useMemo(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const defaultSupportingDocuments: Record<string, any> = {};

    Object.entries(CODE_META).forEach(([code, meta]) => {
      // media baru diupload pakai type=code, media lama masih pakai legacyType
      const media = medias?.find(
        (item) => item.type === code || item.type === meta.legacyType,
      );
      if (media) {
        defaultSupportingDocuments[code] = media;
      }
    });

    return defaultSupportingDocuments;
  }, [medias]);

  return defaultSupportingDocuments;
}
